var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import Characteristic from "./Characteristic";
import { ResourceType } from "./Resource";
import { Company } from "./Company";
import User from "./User";
var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.characteristics = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Profile.buildFromJson(_this, obj);
        return _this;
    }
    Object.defineProperty(Profile.prototype, "user", {
        get: function () {
            if (this.r1 === this.r2) {
                if (this.r1_data != null && this.r2_data != null) {
                    if (this.r1_data.resourceType === ResourceType.USER) {
                        return this.r1_data;
                    }
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Profile.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === "characteristics") {
                        instance[prop] = [];
                        for (var subProp in json[prop]) {
                            instance[prop].push(new Characteristic(json[prop][subProp]));
                        }
                    }
                    else if (prop === "r1_data" || prop === "r2_data") {
                        if (prop === "r1_data" || prop === "r2_data") {
                            if (json[prop].resourceType === ResourceType.USER) {
                                instance[prop] = new User(json[prop]);
                            }
                            else if (json[prop].resourceType === ResourceType.COMPANY) {
                                instance[prop] = new Company(json[prop]);
                            }
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Profile.prototype.exportToJson = function () {
        var JSONProfile = {};
        JSONProfile.uid = this.uid;
        JSONProfile.r1 = this.r1;
        JSONProfile.r2 = this.r2;
        JSONProfile.characteristics = [];
        for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
            var characteristic = _a[_i];
            JSONProfile.characteristics.push(characteristic.exportToJson());
        }
        JSONProfile.createdAt = this.createdAt;
        return JSONProfile;
    };
    Profile.prototype.getUser = function () {
        if (this.r1_data.resourceType === ResourceType.USER
            && this.r1_data instanceof User) {
            return this.r1_data;
        }
        else if (this.r2_data.resourceType === ResourceType.USER
            && this.r2_data instanceof User) {
            return this.r2_data;
        }
        return null;
    };
    Profile.prototype.getCompany = function () {
        if (this.r1_data.resourceType === ResourceType.COMPANY
            && this.r1_data instanceof Company) {
            return this.r1_data;
        }
        else if (this.r2_data.resourceType === ResourceType.COMPANY
            && this.r2_data instanceof Company) {
            return this.r2_data;
        }
        return null;
    };
    Profile.getCorrespondingProfile = function (profileUid, profiles) {
        for (var _i = 0, profiles_1 = profiles; _i < profiles_1.length; _i++) {
            var profile = profiles_1[_i];
            if (profile.uid === profileUid) {
                return profile;
            }
        }
        return null;
    };
    Profile.prototype.isDirect = function () {
        return this.r1 === this.r2;
    };
    Profile.prototype.isDirectCompany = function () {
        if (this.r1_data) {
            return this.r1_data.resourceType === ResourceType.COMPANY && this.isDirect();
        }
        return false;
    };
    Profile.prototype.isDirectUser = function () {
        if (this.r1_data) {
            return this.r1_data.resourceType === ResourceType.USER && this.isDirect();
        }
        return false;
    };
    Profile.prototype.isJustProfile = function () {
        return this.resourceType === "PROFILE" && !this.isDirectCompany() && !this.isDirectUser();
    };
    Object.defineProperty(Profile.prototype, "fullname", {
        get: function () {
            var _a, _b;
            if (this.r1_data instanceof User) {
                return (_a = this.r1_data.first_name) !== null && _a !== void 0 ? _a : ' ' + (this.r1_data.last_name !== null ? this.r1_data.last_name.toUpperCase() : '');
            }
            else {
                return (_b = this.r1_data.name) !== null && _b !== void 0 ? _b : "";
            }
        },
        enumerable: false,
        configurable: true
    });
    return Profile;
}(Model));
export default Profile;
//# sourceMappingURL=Profile.js.map